import './Roles.scss';
import AppBar from 'components/organisms/AppBar/AppBar';
import Footer from 'components/organisms/Footer/Footer';
import { HelmetAndPageAnnouncer } from 'components/organisms/HelmetAndPageAnnouncer/HelmetAndPageAnnouncer';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import RoleCardsListContainer from './RoleCardsListContainer/RoleCardsListContainer';

interface IRoles {}

const Roles: FC<IRoles> = () => {
  const { t } = useTranslation();

  return (
    <>
      <HelmetAndPageAnnouncer pageTitle={t('roles.listOfRoles')} />
      <div className="Roles" aria-live="polite">
        <AppBar />
        <main>
          <RoleCardsListContainer />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Roles;
